<template><div><h2 id="nowrap" tabindex="-1" class="d-docsite--header-2">Nowrap <a class="header-anchor d-link d-docsite--link d-link" href="#nowrap" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-tw-nowrap</code> to prevent text from wrapping.</p>
<code-example source-code='&lt;div class=&quot;d-bgc-moderate d-py-100 d-px-200 d-bar-400 d-w-500 d-of-hidden&quot;&gt;
  &lt;p class=&quot;d-tw-nowrap&quot;&gt;Lorem ipsum dolor sit amet consectetur gemini.&lt;/p&gt;
&lt;/div&gt;'>
<div class="d-bgc-moderate d-py-100 d-px-200 d-bar-400 d-w-500 d-of-hidden">
  <p class="d-tw-nowrap">Lorem ipsum dolor sit amet consectetur gemini.</p>
</div>
</code-example>
<h2 id="wrap" tabindex="-1" class="d-docsite--header-2">Wrap <a class="header-anchor d-link d-docsite--link d-link" href="#wrap" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-tw-wrap</code> to allow text to wrap normally at soft wrap opportunities.</p>
<code-example source-code='&lt;div class=&quot;d-bgc-moderate d-py-100 d-px-200 d-bar-400 d-w-500&quot;&gt;
  &lt;p class=&quot;d-tw-wrap&quot;&gt;Lorem ipsum dolor sit amet consectetur gemini.&lt;/p&gt;
&lt;/div&gt;'>
<div class="d-bgc-moderate d-py-100 d-px-200 d-bar-400 d-w-500">
  <p class="d-tw-wrap">Lorem ipsum dolor sit amet consectetur gemini.</p>
</div>
</code-example>
<h2 id="balance" tabindex="-1" class="d-docsite--header-2">Balance <a class="header-anchor d-link d-docsite--link d-link" href="#balance" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-tw-balance</code> to balance the length of each line of text, distributing content more evenly across lines.</p>
<code-example source-code='&lt;div class=&quot;d-bgc-moderate d-py-100 d-px-200 d-bar-400 d-w-500&quot;&gt;
  &lt;p class=&quot;d-tw-balance&quot;&gt;Lorem ipsum dolor sit amet consectetur gemini.&lt;/p&gt;
&lt;/div&gt;'>
<div class="d-bgc-moderate d-py-100 d-px-200 d-bar-400 d-w-500">
  <p class="d-tw-balance">Lorem ipsum dolor sit amet consectetur gemini.</p>
</div>
</code-example>
<h2 id="pretty" tabindex="-1" class="d-docsite--header-2">Pretty <a class="header-anchor d-link d-docsite--link d-link" href="#pretty" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-tw-pretty</code> to optimize text wrapping for better typography, avoiding orphaned words on the last line.</p>
<code-example source-code='&lt;div class=&quot;d-bgc-moderate d-py-100 d-px-200 d-bar-400 d-w-500&quot;&gt;
  &lt;p class=&quot;d-tw-pretty&quot;&gt;Lorem ipsum dolor sit amet consectetur gemini.&lt;/p&gt;
&lt;/div&gt;'>
<div class="d-bgc-moderate d-py-100 d-px-200 d-bar-400 d-w-500">
  <p class="d-tw-pretty">Lorem ipsum dolor sit amet consectetur gemini.</p>
</div>
</code-example>
<h2 id="unset" tabindex="-1" class="d-docsite--header-2">Unset <a class="header-anchor d-link d-docsite--link d-link" href="#unset" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-tw-unset</code> to reset the text wrap property to its default value.</p>
<code-example source-code='&lt;div class=&quot;d-bgc-moderate d-py-100 d-px-200 d-bar-400 d-w-500&quot;&gt;
  &lt;p class=&quot;d-tw-unset&quot;&gt;Lorem ipsum dolor sit amet consectetur gemini.&lt;/p&gt;
&lt;/div&gt;'>
<div class="d-bgc-moderate d-py-100 d-px-200 d-bar-400 d-w-500">
  <p class="d-tw-unset">Lorem ipsum dolor sit amet consectetur gemini.</p>
</div>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<new-utility-class-table :classes="textWrap"></new-utility-class-table></div></template>


<script setup>
  import { inject } from 'vue';
  import { extractUtilityClasses } from '@utilities';

  const utilityClassDocs = inject('utilityClassDocs');
  const textWrap = extractUtilityClasses(utilityClassDocs, 'd-tw-');
</script>